import { render, staticRenderFns } from "./CalloutBanner.vue?vue&type=template&id=6d4bd0ef"
import script from "./CalloutBanner.vue?vue&type=script&lang=ts"
export * from "./CalloutBanner.vue?vue&type=script&lang=ts"
import style0 from "./CalloutBanner.vue?vue&type=style&index=0&id=6d4bd0ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports